import { get as _get } from "lodash";
import api from "../../helpers/api";

export const fetchClientPowerBIToken = (powerBIType, variables) => {
  return api().options(`/client/powerbi/${powerBIType}`, { data: (variables || {}) }).then((res) => {
    return {
      flag: _get(res, "data.responseStatus", true),
      message: _get(res, "data.responseMessage", ""),
      data: _get(res, "data.responseData", {}),
    };
  }).catch((err) => {
    return {
      flag: false,
      message: _get(err, "response.data.responseMessage", "Something went wrong while fetching report details."),
      data: {},
    };
  });
};
